import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import invariant from 'invariant';
import { omit } from 'lodash';

var PortalConnector = /*#__PURE__*/function () {
  function PortalConnector() {
    var _this = this;

    _classCallCheck(this, PortalConnector);

    this.nextId = 1;
    this.targetsByName = {};
    this.targetsByChildId = {};
    this.intentionToAdd = {};
    var methodNames = ['registerTarget', 'removeTarget', 'addChild', 'updateChild', 'removeChild'];

    _forEachInstanceProperty(methodNames).call(methodNames, function (name) {
      var _context;

      _this[name] = _bindInstanceProperty(_context = _this[name]).call(_context, _this);
    });
  }

  _createClass(PortalConnector, [{
    key: "registerTarget",
    value: function registerTarget(name, portalTarget) {
      if (this.targetsByName[name]) {
        this.intentionToAdd[name] = portalTarget;
      } else {
        this.targetsByName[name] = {
          targetInstance: portalTarget,
          childrenById: {}
        };
      }
    }
  }, {
    key: "removeTarget",
    value: function removeTarget(name, portalTarget) {
      if (this.targetsByName[name].targetInstance === portalTarget) {
        delete this.targetsByName[name];
      }

      if (this.intentionToAdd[name]) {
        this.registerTarget(name, this.intentionToAdd[name]);
        delete this.intentionToAdd[name];
      }
    }
  }, {
    key: "addChild",
    value: function addChild(targetName, child) {
      var id = "portalId".concat(this.nextId++);
      var target = this.targetsByName[targetName]; // NOTE: we might want to refactor this... atm the portal relies on the
      // fact that the target has already been rendered, which is not really
      // necessary + limits the usage (you cannot use the Portal before the Target
      // in your app). We can easily store the child references even before rendering
      // the Target!

      invariant(target, "No target with name ".concat(targetName, " found."));
      this.targetsByChildId[id] = target;

      if (!child) {
        return id;
      }

      target.childrenById[id] = child;
      target.targetInstance.updateChildren(_Object$values(target.childrenById));
      return id;
    }
  }, {
    key: "updateChild",
    value: function updateChild(id, child) {
      var target = this.targetsByChildId[id];
      invariant(target, "No target with id ".concat(id, " found."));

      if (!child && !target.childrenById[id]) {
        return;
      }

      if (!child) {
        target.childrenById = omit(target.childrenById, id);
      } else {
        target.childrenById[id] = child;
      }

      target.targetInstance.updateChildren(_Object$values(target.childrenById));
    }
  }, {
    key: "removeChild",
    value: function removeChild(id) {
      var target = this.targetsByChildId[id];
      invariant(target, "No target with id ".concat(id, " found."));
      delete this.targetsByChildId[id];

      if (!target.childrenById[id]) {
        return;
      }

      target.childrenById = omit(target.childrenById, id);
      target.targetInstance.updateChildren(_Object$values(target.childrenById));
    }
  }]);

  return PortalConnector;
}();

export { PortalConnector as default };